export let SupportedTpaAppDefIds = /*#__PURE__*/function (SupportedTpaAppDefIds) {
  SupportedTpaAppDefIds["PRO_GALLERY"] = "14271d6f-ba62-d045-549b-ab972ae1f70e";
  SupportedTpaAppDefIds["WIX_VIDEO"] = "14409595-f076-4753-8303-9a86f9f71469";
  SupportedTpaAppDefIds["WIX_SOUNDCLOUD"] = "14a85b13-d7da-ee8e-7290-3b93340f63fa";
  return SupportedTpaAppDefIds;
}({});
//# sourceMappingURL=constants.js.map